import React from 'react';

// Components
import { FormControl, Form, Spinner } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';

// Types
import { IAuditFilter } from './types';

type AuditFiltersPropsTypes = {
  values: IAuditFilter;
  setFieldValue: (field: string, value: any) => void;
  handleSubmit: () => void;
  loading: boolean;
};

const AuditFilters = (props: AuditFiltersPropsTypes) => {
  const { values, handleSubmit, setFieldValue, loading } = props;

  return (
    <div className="w-100">
      <h3 className="mb-3">Журнал аудита</h3>
      <div className="d-flex gap-3 mb-3 flex-wrap align-items-end">
        <div style={{ minWidth: '160px' }}>
          <Form.Label className="mb-1 fs-10">Действие</Form.Label>
          <Form.Select
            size="sm"
            value={values.action || ''}
            onChange={e => setFieldValue('action', e.target.value || undefined)}
            disabled={loading}
          >
            <option value="">Все</option>
            <option value="POST">POST</option>
            <option value="PUT">PUT</option>
            <option value="DELETE">DELETE</option>
          </Form.Select>
        </div>

        <div style={{ minWidth: '200px' }}>
          <Form.Label className="mb-1 fs-10">Ресурс</Form.Label>
          <FormControl
            size="sm"
            type="search"
            value={values.resource || ''}
            onChange={e =>
              setFieldValue('resource', e.target.value || undefined)
            }
            placeholder="Введите ресурс"
            disabled={loading}
          />
        </div>

        <div style={{ minWidth: '200px' }}>
          <Form.Label className="mb-1 fs-10">Дата с</Form.Label>
          <FormControl
            size="sm"
            type="datetime-local"
            value={values.date_from || ''}
            onChange={e =>
              setFieldValue('date_from', e.target.value || undefined)
            }
            disabled={loading}
          />
        </div>

        <div style={{ minWidth: '200px' }}>
          <Form.Label className="mb-1 fs-10">Дата по</Form.Label>
          <FormControl
            size="sm"
            type="datetime-local"
            value={values.date_to || ''}
            onChange={e =>
              setFieldValue('date_to', e.target.value || undefined)
            }
            disabled={loading}
          />
        </div>

        <div>
          {/* @ts-ignore */}
          <IconButton
            className="d-flex align-items-center gap-2"
            variant="primary"
            size="sm"
            disabled={loading}
            icon="search"
            iconAlign="left"
            onClick={handleSubmit}
          >
            Поиск
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : null}
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default AuditFilters;
